import api from '@/utils/axios';
import { unwrapItem, unwrapList } from '@/utils/apiHelpers';

export interface RelayPointDashboard {
  relay_point: {
    id: number;
    name: string;
    address: string;
    opening_hours?: string | null;
  };
  stats: {
    packages_waiting: number;
    packages_in_store: number;
    activities_today: number;
  };
  recent_activities: Array<{
    id: number;
    event_type: string;
    notes?: string | null;
    created_at?: string | null;
  }>;
}

export async function fetchRelayPointDashboard(): Promise<RelayPointDashboard> {
  const res = await api.get('/relay-point/dashboard');
  return unwrapItem<RelayPointDashboard>(res.data);
}

export async function fetchRelayPointPackages() {
  const res = await api.get('/relay-point/packages');
  return unwrapList(res.data);
}

export async function fetchRelayPointStaffActivities() {
  const res = await api.get('/relay-point/activities');
  return unwrapList(res.data);
}

export async function logRelayPointStaffActivity(payload: {
  event_type: string;
  order_request_id?: number | null;
  notes?: string | null;
}) {
  const res = await api.post('/relay-point/activities', payload);
  return unwrapItem(res.data);
}
